import { render, staticRenderFns } from "./customerApproval.vue?vue&type=template&id=ff1bf0b4&scoped=true"
import script from "./customerApproval.vue?vue&type=script&lang=js"
export * from "./customerApproval.vue?vue&type=script&lang=js"
import style0 from "./customerApproval.vue?vue&type=style&index=0&id=ff1bf0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1bf0b4",
  null
  
)

export default component.exports